import getAllLawyers from '../../api/queries/lawyers/getAllLawyers';
import getLawyerBySlug from '../../api/queries/lawyers/getLawyerBySlug';
import createApolloClient from '../../api/index';
import getMenu from '../../api/queries/menus/getMenu';

import PageLayout from '../../components/PageLayout';
import DynamicSection from '../../components/DynamicSections';
import Breadcrumb from '../../components/Breadcrumb';

const client = createApolloClient();

const LawyerSingle = ({ data, desktopHeaderData, aboutMenuData,serviceMenuData, toolsMenuData }) => {
  const lawyerName = data.teamBy.title;
  const lawyerData = data.teamBy.lawyers;
  const reviews = data.teamBy.lawyers.reviews.review;
  const sections = data.teamBy.sections.sections;
  const yoastSeo = data?.teamBy?.seo;
  const indexStatus = data?.teamBy?.indexPage;

  return (
    <PageLayout menuData={desktopHeaderData} aboutMenuData={aboutMenuData} serviceMenuData={serviceMenuData} toolsMenuData={toolsMenuData} title={`Lawyer - ${lawyerName}`} classNames="lawyer" yoastSeo={yoastSeo} indexStatus={indexStatus}>
      <Breadcrumb data={data}/>
      <h3>{lawyerName}</h3>
      <p className="lawyer__job">{lawyerData.jobTitle}</p>
      <div>
        <DynamicSection sections={data.teamBy.sections.sections} />
      </div>
      <div className="lawyer__reviews">
        <div className="lawyer__reviews__header">
          <img data-src="../images/small-blue-stars.svg" width="250" alt="blue-stars" />
          <h3>What our clients say</h3>
        </div>
        {reviews.map((review) => (
          <div className="lawyer__reviews__single">
            <p className="lawyer__reviews__single__header">
              <strong><i>{review.name}</i></strong>
              <small><i>"{review.mainQuote}"</i></small>
            </p>
            <p className="lawyer__reviews__single__body"><i>"{review.text}"</i></p>
            <div className="lawyer__reviews__single__footer">
              <img data-src="../images/small-blue-stars.svg" alt="small-blue-stars" width="120" />
              <a href={review.platformLink} target="_blank">
                {
                  review.platform === "google" ?
                  <img data-src="../images/google-icon.svg" alt="google-review" className="lawyer__reviews__single__footer__review-icon" /> :
                  review.platform === "reviewsio" ?
                  <img data-src="../images/reviewsio-icon.svg" alt="reviewsio-icon" className="lawyer__reviews__single__footer__review-icon"/> :
                  review.platform === "yell" ?
                  <img data-src="../images/yell-icon.svg" alt="yell-icon" className="lawyer__reviews__single__footer__review-icon"/> :
                  review.platform === "trustpilot" ?
                  <img data-src="../images/trustpilot-icon.svg" alt="yell-icon" className="lawyer__reviews__single__footer__review-icon"/> :
                  review.platform
                }
              </a>
            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  );
};

export default LawyerSingle;

export const getStaticPaths = async () => {
  const { data } = await client.query(getAllLawyers());

  const paths = data.lawyers.nodes.map(({ slug }) => ({
    params: { slug: [slug] },
  }));

  return {
    paths,
    fallback: false,
  };
};

export async function getStaticProps({ params }) {
  const { slug } = params;

  const { data } = await client.query(getLawyerBySlug(slug[0]));
  const serviceMenuId = process.env.APP_ENV === 'stage' ? 'dGVybTo2Mg==' : 'dGVybTo2Ng==';
  const desktopHeaderData = await client.query(getMenu('dGVybToyNQ=='));
  const aboutMenuData = await client.query(getMenu('dGVybTo1NQ=='));
  const serviceMenuData = await client.query(getMenu(serviceMenuId));
  const toolsMenuData = await client.query(getMenu('dGVybTo1Ng=='));

  return { props: { data, desktopHeaderData, aboutMenuData,serviceMenuData, toolsMenuData }, revalidate: 10 };
}
